export default __webpack_public_path__ + "img/fTUBcIox.6249c558.svg";